import MessagingListCard from './MessagingListCard';

export default MessagingListCard;
